module.exports = __webpack_public_path__ + "media/yage.f21a2ad1.mp4";